module.exports = "<example-shell\n  exampleId=\"headerless\" [title]=\"title\" [summary]=\"summary\" [dataSnippet]=\"dataSnippet\" [events]=\"events\" (clear)=\"clearEvents()\">\n  <stackline-data-table\n    title=\"Compact list\"\n    [columns]=\"orderColumns\"\n    [data]=\"orders\"\n    [noHeader]=\"true\"\n    [noTableHead]=\"true\"\n    [dense]=\"true\"\n    [highlightOnHover]=\"true\">\n  </stackline-data-table>\n</example-shell>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/headerless/headerless.component.html
// module id = ./src/app/examples/headerless/headerless.component.html
// module chunks = main